import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router";

import { ListItem, ListItemButton, Tooltip } from "@mui/material";

import { NavItem } from "../../Navigation.types";
import { NavigationItemIcon } from "./components/navigation-icon/NavigationItemIcon";
import { NavigationItemLabel } from "./components/navigation-label/NavigationItemLabel";

interface Props {
  navigationItem: NavItem;
  isCollapsed: boolean;
}

export function NavigationItem({ navigationItem, isCollapsed }: Props) {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = decodeURIComponent(location.pathname);

  const isSelected = pathname.startsWith(navigationItem.path + "/") || pathname === navigationItem.path;

  const label = t(navigationItem.label);

  return (
    <ListItem disablePadding>
      <Tooltip title={label} disableHoverListener={!isCollapsed} placement="right" arrow>
        <ListItemButton
          component={NavLink}
          to={{ pathname: navigationItem.path, search: navigationItem.params?.toString() }}
          onClick={navigationItem.onClick}
          selected={isSelected}
          aria-current={isSelected ? "page" : undefined}
          aria-label={navigationItem.count ? `${label} (${navigationItem.count})` : label}
          sx={{
            height: 32,
            px: isCollapsed ? 0 : 2,
            py: 0.75,
            justifyContent: isCollapsed ? "center" : "flex-start",
            borderRadius: 0.5,

            "&:not(.active) .MuiListItemIcon-root": { color: "action.active" },

            "&:hover:not(.active)": {
              backgroundColor: "fsw.blue-10",

              "& .MuiListItemIcon-root": { color: "text.primary" },
            },

            "&.active": {
              backgroundColor: "fsw.blue-10",

              "& .MuiListItemIcon-root": { color: "fsw.darkerblue" },
            },
          }}
        >
          <NavigationItemIcon icon={navigationItem.icon} count={navigationItem.count} isCollapsed={isCollapsed} />
          {!isCollapsed && <NavigationItemLabel label={navigationItem.label} count={navigationItem.count} />}
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
}
